import { useState, useEffect, useCallback, useRef } from "react";

export function useFetch(fetcher, deps = []) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  const run = useCallback(async () => {
    setLoading(true);
    setError(null);
    try { setData(await fetcherRef.current()); }
    catch (e) { setError(e); }
    finally { setLoading(false); }
  }, []); // eslint-disable-line

  useEffect(() => { run(); }, deps); // eslint-disable-line

  return { data, loading, error, reload: run };
}
